$(document).ready(function() {

    if ($('body.page-clinica').length) {
        $('body').scrollspy({
            target: '#navbar-clinica-box',
            offset: 80
        });

        qp = getQueryParams();
        if(qp.hasOwnProperty('widget')) {
            let location = window.location; 
            let idClinica = location.pathname.split('/')[2];

            idClinica = idClinica.split('-')[0];
            if (!idClinica) return;
            httpRequest(api_url + 'frontend/widget-clinica', {widget: qp.widget, id: idClinica, isClinica: true}, {showLoader: false}).then(data => {
                
            })
        }

        $('.reload-lista-medici').on('change', function(e) {
            loadMediciClinica();
        });

        window.loadMediciClinica = function() {
            if (!$('#clinica-specialisti').data('id')) {
                return;
            }
            const formData = {
                idSpecializzazione:$('#specializzazione').val(),
                idSede:$('#studio').val(),
            }
            const url = api_url + 'frontend/clinica/' + $('#clinica-specialisti').data('id') + '/lista-medici';

            httpRequest(url, formData).then(onResult => {
                $('#containerRows').html(onResult.html);
                btnRichiediDispBind();
            });
        }

        loadMediciClinica();
        if (document.getElementById('map')) {
            $.getScript($("#map").data('leaflet'), function() {
                $.getScript($("#map").data('script'), function() {
                    initialize_mappa_liste();
                });
            });
        }

        var is_mobile = $(window).width() <= 768;
        clinicaPrenotaStickyButton();

        //bottone stickybottom
        function clinicaPrenotaStickyButton() {
            var clinicaPrenotaMobile = $('#clinica-prenota-mobile').first();
            $(document).off('scroll');
            //header con logo
            var headLogo = $('.page-clinica > .bg-primary').first().outerHeight();
            var breadCrumb = $('.breadcrumb').first().outerHeight();
            var clinicaTop = $('.clinica-top').first().outerHeight();
            var clinicaBox = $('#navbar-clinica-box-container').first().outerHeight();
            var offset = clinicaBox * 1.2;
            var navbarLimit = headLogo + breadCrumb + clinicaTop + clinicaBox + offset;

            if (clinicaPrenotaMobile.length && is_mobile) {
                $(document).on('scroll', function(){
                    var scrollTop = $(document).scrollTop();
                    var containerHeight = $('#stepper-container').height() - 150;
                    var navbar = $('#navbar-clinica-box-container');

                    if (scrollTop > navbarLimit) {
                        //add style position:sticky to navbar
                        navbar.addClass('sticky-top');
                    } else {
                        navbar.removeClass('sticky-top');
                    }

                    if(scrollTop > containerHeight && !clinicaPrenotaMobile.hasClass('sticky-footer-sticked')) {
                        clinicaPrenotaMobile.addClass('sticky-footer-sticked');
                        clinicaPrenotaMobile.removeClass('d-none');
                        clinicaPrenotaMobile.addClass('d-block');
                        return;
                    }

                    if(scrollTop <= containerHeight && clinicaPrenotaMobile.hasClass('sticky-footer-sticked')) {
                        clinicaPrenotaMobile.removeClass('sticky-footer-sticked');
                        clinicaPrenotaMobile.addClass('d-none');
                        clinicaPrenotaMobile.removeClass('d-block');
                    }
                });
            }
        }
        //questo per il resize
        $(window).on('resize', function() {
            is_mobile = $(window).width() <= 768;
            clinicaPrenotaStickyButton();
        });
        //click con highlight sulla prenotazione
        document.addEventListener('click', function (event) {
            if (is_mobile) return;
            //il click è in modale, non fare nulla

            if (event.target.closest('.modal')) return;
            //controlliamo il parent
            var stepperContainer = event.target.closest('#stepper-container');
            var stepCon = document.querySelector('#stepper-container');

            if (! stepCon) {
                return;
            }
            var wasHighlight = stepCon.classList ? stepCon.classList.contains('highlight') : false;

            if (!stepperContainer && wasHighlight) {
                //il click è avvenuto fuori dallo steperrContainer, rimuoviamo la classe highlight
                if (stepCon) stepCon.classList.remove('highlight');
                //posso eliminare l'elemento con classe modal-backdrop
                var modalBackdrop = document.querySelector('.modal-backdrop');
                if (modalBackdrop) modalBackdrop.remove();
                //rimuovo la classe d-none dalla mappa
                document.querySelector('#map-container').classList.add('d-lg-block');
                return;
            }

            if (!stepperContainer || wasHighlight) {
                return;
            }

            //aggiungiamo la classe highlight
            stepperContainer.classList.add('highlight');
            //creiamo il div con classe modal-backdrop
            var modalBackdrop = document.createElement('div');
            modalBackdrop.classList.add('modal-backdrop', 'show');
            //add an id
            modalBackdrop.id = 'modal-backdrop-stepper';
            //appendiamolo al body
            document.body.appendChild(modalBackdrop);
            modalBackdropStepper = document.querySelector('#modal-backdrop-stepper');
            //necessario per l'highlight
            modalBackdropStepper.style.zIndex = 998;
            //nascondiamo la mappa
            document.querySelector('#map-container').classList.remove('d-lg-block');

        }, false);

        var mapIcon = L.icon({
            iconUrl: base_url+"marker.svg",
            iconSize: [29, 40],
            popupAnchor: [0, -20],
        });
        var mapIconHover = L.icon({
            iconUrl: base_url+"marker_open.svg",
            iconSize: [29, 40],
            popupAnchor: [0, -20],
        });
        var mapIconMe = L.icon({
            iconUrl: base_url+"marker_me.svg",
            iconSize: [29, 40],
            popupAnchor: [0, -20],
        });

        $('.dettaglio-sede-clinica').on('click', function(e) {
            e.preventDefault();
            var id = $(this).data('id');
            var url = api_url + 'frontend/clinica/sedi/dettaglio/' + id;


            httpRequest(url).then(onResult => {

                $('#dettaglio-sede-clinica').removeClass().addClass('modal');
                $('#dettaglio-sede-clinica').addClass(onResult.modalClass);
                $('#dettaglio-sede-clinica .modal-dialog').removeClass().addClass('modal-dialog').addClass(onResult.modalType);
                $('#dettaglio-sede-clinica .modal-content').html(onResult.html);
                $('#dettaglio-sede-clinica').modal('show');

                var mapSede = $('#map-sede');
                setTimeout(function() {

                    if (mapSede.length) {
                        var latitude = mapSede.data('lat');
                        var longitude = mapSede.data('long');
                        var latLong = [latitude, longitude];
                        var zoom = 16;
                        var maxZoom = 19;

                        var mapOptions = {
                            maxZoom: maxZoom,
                            zoom: zoom,
                            scrollWheelZoom: false,
                            layers: new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
                                maxZoom: maxZoom,
                                attribution: '<a href="https://openstreetmap.org">© OpenStreetMap</a>'
                            })
                        };
                        var map = L.map('map-sede', mapOptions).setView(latLong, zoom);
                        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
                        L.marker(latLong, {icon: mapIcon, alt: 'map marker'}).addTo(map);
                    }
                }, 200);

            });
        });

        window.chiamaClinica = function(id) {
            const formData = {
                id: id,
            }
            const url = api_url + 'frontend/clinica/chiama';
            httpRequest(url, formData).then(onResult => {
                if (!onResult.result) {
                    if (onResult.error) return showError(onResult.error);
                    this.listErrorOnSubmit = onResult.data;
                    return;
                }
                $('#telClinica').html('<a href="tel:' + onResult.data.numero + '" onclick="contaChiama(' + id + ')"><i class="fas fa-phone-alt"></i> ' + onResult.data.numero + '</a>');
                $('#telClinicaModal').modal('show');
            });
        }

        window.contaChiama = function(id) {
            const formData = {
                id: id,
            }
            const url = api_url + 'frontend/clinica/conta-chiama';
            httpRequest(url, formData).then(onResult => {
                if (!onResult.result) {
                    if (onResult.error) return showError(onResult.error);
                    this.listErrorOnSubmit = onResult.data;
                    return;
                }
            });
        }
    }

});

window.elInViewPort = function(el, subtractHeight = 0) {
    if (!$(el).length) return;
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        (rect.bottom - subtractHeight) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.selezionaMedicoDisponibilita = function(idMedico, idSpecializzazione) {
    if (!window.appListe) return;
    boxOrari = document.getElementById('baseAppSticky');
    console.log(boxOrari, elInViewPort(boxOrari));
    timeO = 0;

    //get map container outerHeight
    var mapContainer = document.getElementById('map-container');
    var mapContainerHeight = mapContainer ? mapContainer.offsetHeight : 0;

    if (boxOrari && !elInViewPort(boxOrari, mapContainerHeight)) {
        boxOrari.scrollIntoView({behavior: "smooth", block: "start"});
        timeO = 50;
    }
    setTimeout(function() {
        window.appListe.$refs.BoxDispClinica.setMedico(idMedico, idSpecializzazione);
    }, timeO);
}

window.triggerPrenotaCliniche = function() {
    if (!window.appListe) return;
    window.appListe.$refs.BoxDispClinica.triggerPrenotaCliniche();
}

window.setTipoVisita = function(tipoVisita) {
    if (!window.appListe) return;
    window.appListe.$refs.BoxDispClinica.setTipoVisita(tipoVisita);
}

window.setSpecializzazione = function(idSpecializzazione) {
    if (!window.appListe) return;
    window.appListe.$refs.BoxDispClinica.setSpecializzazione(idSpecializzazione);

    if (is_mobile) {
        window.scrollTo($('#clinica-box-orari').offset().top - $('#navbar-clinica-box-container').outerHeight());
    }
}
